import Vue from "vue";

export default {
    install () {
        Vue.prototype.$isAdmin= localStorage.getItem('isAdmin') === 'true' ? true : false;

        Vue.prototype.$getUserCategory = parseInt(localStorage.getItem('category'));

        Vue.prototype.$getUserContextID = localStorage.getItem('context_id');

        Vue.prototype.$getUserID = localStorage.getItem('user_id');

        Vue.prototype.$getUserType = localStorage.getItem('type');

        Vue.prototype.$formatDisplayName = function(user) {
            return user.fullname + ' (' + user.nickname + ')';
        };

        Vue.prototype.$convertListUserDisplayName = async function(users) {
            users.forEach(user => {
                user.displayName = user.fullname + '(' + user.nickname + ')'
            })
            return users;
        };
    },
};